import { ApiProperty } from "@nestjs/swagger";

export class RackPositionQtyRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
  }
